// Proposal-text-style markdown subset for rich_text blocks (not full TipTap).

export const RICH_TEXT_HINT =
  "Markdown subset: **bold**, *italic*, - list items, [label](url) links. Plain lines for paragraphs.";

export function wrapRichTextSelection(
  value: string,
  selectionStart: number,
  selectionEnd: number,
  wrap: string,
): { next: string; cursor: number } {
  const before = value.slice(0, selectionStart);
  const selected = value.slice(selectionStart, selectionEnd);
  const after = value.slice(selectionEnd);
  const next = `${before}${wrap}${selected}${wrap}${after}`;
  const cursor = selectionStart + wrap.length + selected.length + wrap.length;
  return { next, cursor };
}

export function prefixRichTextLine(
  value: string,
  selectionStart: number,
  prefix: string,
): { next: string; cursor: number } {
  const lineStart = value.lastIndexOf("\n", selectionStart - 1) + 1;
  const next = `${value.slice(0, lineStart)}${prefix}${value.slice(lineStart)}`;
  return { next, cursor: selectionStart + prefix.length };
}

export function insertRichTextLink(
  value: string,
  selectionStart: number,
  selectionEnd: number,
): { next: string; cursor: number } {
  const label = value.slice(selectionStart, selectionEnd) || "link text";
  const snippet = `[${label}](https://)`;
  const next = `${value.slice(0, selectionStart)}${snippet}${value.slice(selectionEnd)}`;
  const cursor = selectionStart + snippet.length - 1;
  return { next, cursor };
}
